import { render } from "./amy-category-mapping.vue?vue&type=template&id=5d57831e&ts=true"
import script from "./amy-category-mapping.vue?vue&type=script&lang=ts"
export * from "./amy-category-mapping.vue?vue&type=script&lang=ts"

import "./amy-category-mapping.vue?vue&type=style&index=0&id=5d57831e&lang=scss"

import exportComponent from "/Users/brian/VIS Solutions/aeon-boxed-middleware-spa/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__